import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import EmployeesFilter from './EmployeesFilter';

export default function EmployeesStatusFilter() {
	const { t } = useTranslation();

	return (
		<EmployeesFilter
			name="status"
			label={t('employees.filters.userStatus.label')}
			options={[
				{
					label: t('employees.filter.userStatus.active'),
					value: graphql.UserStatus.Active,
				},
				{
					label: t('employees.filter.userStatus.archived'),
					value: graphql.UserStatus.Archived,
				},
				{
					label: t('employees.filter.userStatus.inactive'),
					value: graphql.UserStatus.Inactive,
				},
			]}
		/>
	);
}
